module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAAAXNSR0IArs4c6QAAAP9JREFUOBGdlEEOwiAQRYVew+N0485Fk5ro2p2ncedaFyZd9ADtbbyGqf9X2lBaYGCSSQfCfwxlBtX3/WEYhsfub7eyLFsTiz6aYvjeeNN1XS1SmkXaWVwA9EqBEHCDfy1QEkTzzEqpSy5ETTsj7RPSf2JcTHOEAn7GJm9rbhHOAM7mQBaAHMgKYCA1bwNx9DibgBSIFyCFBAESSBQQgVQigA+CGvm4vcC1SSbKgM3ludYqmkFAzBJvgxlExGN/eAESMX/WJkAq3gSkiFeAVPECkCOeAbniEQDxEUXSYBDtfQpcYyHd4VliwtxKjD6iFNmm0VFXdpXxKvQC28Ip/gE7MN9UXQdzgAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon-more.png
// module id = 427
// module chunks = 2